//Circle animation for funding in knowledge centre
if ( $('.knowledge__status--circle__ani').length ) {

	var inview = new Waypoint.Inview({

		  element: $('.knowledge__status--circle__ani')[0],
		  enter: function(direction) {

				window.zindexing = function () {
					var zIndex = 50;
					$( ".ko-progress-circle" ).each(function() {
						$(this).css('z-index', zIndex);
						var zIndexMinus =  (+zIndex) - 1;
						return zIndex = zIndexMinus;
					}); 
					return zIndex;
				}

				window.randomize = function() {
					var prev = 0;
					$( ".ko-progress-circle" ).each(function() {
						var trueProgress = $(this).attr('data-progressTrue');
						var trueProgress = (+trueProgress) + (+prev);
						if ( trueProgress > 100) {
							var trueProgress = 100;
						}
						$(this).attr('data-progress', trueProgress);
						return prev = trueProgress;
					});
					return prev;



				}
				setTimeout(window.zindexing, 100);
				setTimeout(window.randomize, 500);
		    this.destroy();
		  }
	})
}



// WEBPACK FOOTER //
// ./src/js/circleAnimation.js